import React, { useState } from "react";
import { useQuery } from "react-query";
import { useSnackbar } from "notistack";
import classNames from "classnames";

import { Column, Row } from "components/Layout";
import IntervalBar from "components/IntervalBar/IntervalBar";
import WeatherWidget from "components/WeatherWidget";
import Charts from "./Charts";
import Tables from "./Tables";
import styles from "./_charts.module.scss";

import {
	getTodayData, getWeekData, getMonthData, getCustomData,
	useGetSiteList
} from "service/SolarsmartService";
import { getErrorMessage } from "service/Client";


export default function IntervalPageSolar({type, display}) {

	const [siteId, setSiteId] = useState();
	const [interval, setInterval] = useState("daily");
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const {enqueueSnackbar} = useSnackbar();
	let { sites } = useGetSiteList()

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), { variant: "error" });
	}

	let { data } = useQuery(['data', { nodeId: siteId, interval, startDate, endDate }], () => {
		let promise
		
		if (!siteId) return;
		if (interval === "daily") {
			promise = getTodayData(siteId);
		} else if (interval === "weekly") {
			promise = getWeekData(siteId);
		} else if (interval === "monthly") {
			promise = getMonthData(siteId);
		} else if (startDate !== null && endDate !== null) {
			promise = getCustomData(siteId, startDate.format("DD-MM-YYYY"), endDate.format("DD-MM-YYYY"));
		}
		return promise
	}, {
		enabled: !!siteId && (interval !== 'custom' || (!!startDate && !!endDate)),
		initialData: [],
		onError: showError,
		refetchInterval: (interval === 'daily') ? 10000 : false,
	})

	if(sites.length === 0) return <div/>
	if(!siteId) {
		setSiteId(sites[0].device.id)
	}

	let nodeObj = sites.find(s => s.device.id === siteId);

	return (
		<div className={classNames("animated", "fadeIn", styles.box)}>
			<IntervalBar
				devices={sites.map(n => ({ device: n.device.id, label: n.device.label || n?.plant?.plantName || n.device.deviceId }))}
				device={siteId}
				setDevice={setSiteId}
				interval={interval}
				setInterval={setInterval}
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
				showForecastBtn={false}
			/>

			{
				display === "charts" &&
					<>
						<Charts data={data} type={type} />
						{nodeObj && <Row>
							<Column>
								<div className={styles.weatherWidgetContainer}>
									<WeatherWidget
										lat={nodeObj.lat}
										lng={nodeObj.lng}
										type="forecast"
									/>
								</div>
							</Column>
						</Row>}
					</>
			}
			{
				display === "table" && <Tables data={data} type={type}/>
			}
		</div>
	);
}
